import List from './list/AssessmentTypeListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})